import { render, staticRenderFns } from "./filters-wrapper.vue?vue&type=template&id=1ce56c46"
import script from "./filters-wrapper.vue?vue&type=script&lang=ts"
export * from "./filters-wrapper.vue?vue&type=script&lang=ts"
import style0 from "./filters-wrapper.vue?vue&type=style&index=0&id=1ce56c46&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports